import type { ErrorCode } from '@durakapp/engine';
import type { ServerErrorCode } from '@durakapp/shared';

/**
 * Russian-only for now — Telegram Mini App audience is RU-first.
 * Engine-level codes from the server are mapped to player-facing text here so the
 * backend can stay locale-agnostic.
 */
const RU: Record<ErrorCode | ServerErrorCode, string> = {
  // engine errors (from packages/engine)
  NOT_YOUR_TURN: 'Сейчас не ваш ход',
  INVALID_CARD: 'Эта карта не подходит',
  CARD_NOT_IN_HAND: 'Этой карты нет в руке',
  CANNOT_BEAT: 'Этой картой не побить',
  WRONG_PHASE: 'Сейчас нельзя так ходить',
  TABLE_LIMIT_REACHED: 'На столе уже максимум карт',
  INVALID_THROW_IN_RANK: 'Можно подкидывать только ранги, что есть на столе',
  GAME_FINISHED: 'Партия уже окончена',
  NOTHING_TO_DEFEND: 'Эту карту уже отбили',
  NOTHING_TO_PASS: 'Сейчас нечего отбивать',
  // wire-level / billing errors
  RATE_LIMIT: 'Слишком часто — подождите секунду',
  NOT_PARTICIPANT: 'Вы не участник этой партии',
  UNKNOWN_MATCH: 'Партия не найдена',
  UNAUTHENTICATED: 'Сессия истекла, перезайдите',
  BAD_REQUEST: 'Что-то не так с запросом',
  INTERNAL_ERROR: 'Внутренняя ошибка сервера',
};

/**
 * Translate a server error code to Russian. Falls back to the original message
 * if the code is unknown (so we surface SOMETHING rather than swallowing).
 */
export function translateError(code: string, fallback?: string): string {
  if (code in RU) return RU[code as keyof typeof RU];
  // INSUFFICIENT_BALANCE:N is a synthetic code from the lobby flow.
  if (code.startsWith('INSUFFICIENT_BALANCE')) return 'Не хватает звёзд для этой ставки';
  return fallback ?? 'Что-то пошло не так';
}

const TOAST_RU = {
  connectionLost: 'Соединение потеряно — пересоединяемся…',
  paymentCancelled: 'Пополнение отменено',
  paymentCredited: 'Зачислено · повторяем поиск',
  paymentCreditedSimple: 'Зачислено',
  paymentNeeded: (needed: number) => `Не хватает ${needed} фишек — открываем пополнение`,
  paymentUnavailable: 'Пополнение доступно только внутри Telegram',
  paymentFailed: (status: string) => `Платёж: ${status}`,
  refundReturned: 'Стейк возвращён',
  queued: (n: number, stake: number) =>
    stake > 0 ? `В очереди · ${n} мест · ставка ${stake}` : `В очереди · ${n} мест`,
} as const;

export const t = TOAST_RU;
